var CheckoutPage = {};

CheckoutPage.billingFields = [
  {name: "billingFirstName", required: true},
  {name: "billingLastName", required: true},
  {name: "billingEmail", required: true},
  {
    name: "billingPhone", required: true, regexp: function (input, form) {
      var phone = input.value.replace(/-|\s+/g, "");
      if (input.value && !/^(\+[0-9]{2})*[0-9]{9}$/g.test(phone)) {
        return false;
      }
      return true;
    }
  },
  {name: "billingStreet", required: true},
  {name: "billingHouseNumber", required: true},
  {
    name: "billingZip", required: true, regexp: function (input, form) {
      var postcode = input.value.replace(/\s+/g, "");
      if (postcode && !/^[0-9]{2}-[0-9]{3}$/g.test(postcode)) {
        return false;
      }
      return true;
    }
  },
  {name: "billingCity", required: true},
  {
    name: "billingVatID", required: function (input, form) {
      if (form.elements.hasInvoice.checked && !input.value) {
        return false;
      }
      return true;
    }
  },
];

CheckoutPage.deliveryFields = [
  {name: "deliveryFirstName", required: true},
  {name: "deliveryLastName", required: true},
  {
    name: "deliveryPhone", required: true, regexp: function (input, form) {
      var phone = input.value.replace(/-|\s+/g, "");
      if (input.value && !/^(\+[0-9]{2})*[0-9]{9}$/g.test(phone)) {
        return false;
      }
      return true;
    }
  },
  {name: "deliveryStreet", required: true},
  {name: "deliveryHouseNumber", required: true},
  {
    name: "deliveryZip", required: true, regexp: function (input, form) {
      var postcode = input.value.replace(/\s+/g, "");
      if (postcode && !/^[0-9]{2}-[0-9]{3}$/g.test(postcode)) {
        return false;
      }
      return true;
    }
  },
  {name: "deliveryCity", required: true}
];

CheckoutPage.init = function () {
  CheckoutPage.deliveryMethodId = $('.choosed a').attr('id');
  CheckoutPage.inpostMaps = [];

  $('.form-error').hide();

  var inpostPostboxIndexCounter = 0;

  $('.checkout__delivery .table-body .item > a').each(function (i, link) {
    var $item = $(link).parent();
    var $form = $item.find('form');

    $('[name="warehouse"]').select2();

    CheckoutPage.hasDiliveryAddress = $form.find('[name="hasDeliveryAddress"]').val() == 'true';

    if (link.dataset.sysName === "inpost_postbox") {
      CheckoutPage.inpostMaps[inpostPostboxIndexCounter] = new InpostMap().init(".with-map", {
        initValue: $item.find('[name=postbox]').val()
      }, inpostPostboxIndexCounter++);
    }

    $(link).click(function () {
      CheckoutPage.selectDeliveryMethod(this.id);
    });

    $item.find('[name="hasInvoice"]').change(function () {
      CheckoutPage.toggleToInvoice($item);
    });
    $item.find('#addDeliveryAddress a').click(function () {
      CheckoutPage.addDeliveryAddress($form);
    });
    $item.find('#removeDeliveryAddress a').click(function () {
      CheckoutPage.removeDeliveryAddress($form);
    });

    CheckoutPage.isInvoice = $item.find('[name="invoice"]').val() === 'true';

    $item.find('button[type=submit]').click(function (event) {
      event.preventDefault();
      var errors = CheckoutPage.validateForm($form[0]);
      if (!errors.length) {
        $(this).parents('form').submit();
      }
    });
  });
};

CheckoutPage.selectDeliveryMethod = function (id) {
  //just toggle
  if (CheckoutPage.deliveryMethodId === id) {
    $('#' + id).parent().toggleClass('choosed').find('.item__details').toggle();
    return;
  }
  if (CheckoutPage.deliveryMethodId) {
    $('#' + CheckoutPage.deliveryMethodId).parent().removeClass('choosed').find('.item__details').hide();
  }
  CheckoutPage.deliveryMethodId = id;
  $('#' + id).parent().addClass('choosed').find('.item__details').show();
};


// CheckoutPage.init = function () {
//
//
//   if (!document.forms.checkoutDelivery) {
//     return;
//   }
//
//   CheckoutPage.fields = document.forms.checkoutDelivery.elements;
//
//   InpostMap.init(".with-map", {
//     initValue: CheckoutPage.fields.postbox.value
//   });
//
//   $('#hasInvoice').change(CheckoutPage.toggleToInvoice);
//   $('#addDeliveryAddress a').click(CheckoutPage.addDeliveryAddress);
//   $('#removeDeliveryAddress a').click(CheckoutPage.removeDeliveryAddress);
//   CheckoutPage.isInvoice = $('#hasInvoice').prop("checked");
//   $('button[type=submit]').click(function (event) {
//     var errors = CheckoutPage.validateForm();
//     if (errors.length) {
//       event.preventDefault();
//     }
//   });
//   $('select').select2();
//   $('[name="deliveryMethod"]').change(function (input) {
//     CheckoutPage.onDeliveryMethodChange({
//       _id: input.currentTarget.value,
//       sysName: input.currentTarget.dataset.system,
//       paymentMethods: JSON.parse(input.currentTarget.dataset.payments)
//     });
//   });
// };
//
CheckoutPage.validateForm = function (form) {
  form = form || document.forms.checkoutDelivery;
  Forms.clearFormErrors(form);
  var errors = Forms.validateFields(form, CheckoutPage.billingFields);
  if (CheckoutPage.hasDiliveryAddress) {
    Forms.validateFields(form, CheckoutPage.deliveryFields, errors);
  }
  var deliveryMethod = form.elements.deliveryMethod.value;
  var paymentMethod = form.elements.paymentMethod.value;
  if (!deliveryMethod || !paymentMethod) {
    errors.length++;
    errors.deliveryMethod = {required: true};
    $('[data-for="deliveryMethod"][data-kind="required"]').show();
  } else {
    $('[data-for="deliveryMethod"][data-kind="required"]').hide();
  }


  if (deliveryMethod) {
    var deliverySysName = $('#' + deliveryMethod).data("sysName");

    if (deliverySysName === "inpost_postbox" && !form.postbox.value) {
      errors.length++;
      errors.postbox = {required: true};
      $('[data-for="postbox"][data-kind="required"]').show();
    }
  } else {
    $('[data-for="postbox"][data-kind="required"]').hide();
  }
  return errors;
};
//
// CheckoutPage.onDeliveryMethodChange = function (deliveryMethod) {
//   $('#paymentMethods input').prop('checked', false);
//   if (deliveryMethod.paymentMethods && deliveryMethod.paymentMethods.length) {
//     $('#paymentMethods').show();
//     $('#paymentMethods label').hide();
//     deliveryMethod.paymentMethods.forEach(function (method) {
//       $('[for="' + method._id + '"]').show();
//     });
//   } else {
//     $('#paymentMethods').hide();
//   }
//   if (deliveryMethod.sysName === "manual") {
//     $('.with-warehouse').show();
//   } else {
//     $('.with-warehouse').hide();
//   }
//   if (deliveryMethod.sysName === "inpost_postbox") {
//     if (CheckoutPage.hasDiliveryAddress && CheckoutPage.fields.deliveryCity.value) {
//       InpostMap.show({address: CheckoutPage.fields.deliveryCity.value});
//     } else if (CheckoutPage.fields.billingCity.value) {
//       InpostMap.show({address: CheckoutPage.fields.billingCity.value});
//     } else {
//       InpostMap.show();
//     }
//   } else {
//     InpostMap.hide();
//     $('.with-map').hide();
//   }
// };
//

CheckoutPage.toggleToInvoice = function ($form) {
  if (CheckoutPage.isInvoice) {
    $form.find('[name="billingCompanyName"]').parent().hide();
    $form.find('[name="billingVatID"]').parent().hide();
  } else {
    $form.find('[name="billingCompanyName"]').parent().show();
    $form.find('[name="billingVatID"]').parent().show();
  }
  CheckoutPage.isInvoice = !CheckoutPage.isInvoice;
};

CheckoutPage.addDeliveryAddress = function ($form) {
  CheckoutPage.hasDiliveryAddress = true;
  $('#deliverySection').show();
  $('#addDeliveryAddress').hide();
  $('#deliveryCompanyName').focus();
  $('html, body').animate({
    scrollTop: $("#deliverySection").offset().top
  }, 1000);

  $form.find('[name="hasDeliveryAddress"]').val("true");
};
//
CheckoutPage.removeDeliveryAddress = function ($form) {
  CheckoutPage.hasDiliveryAddress = false;
  $form.find('[name="hasDeliveryAddress"]').val("false");
  $('#deliverySection').hide();
  $('#addDeliveryAddress').show();
};


var InpostMap = function () {
  var self = this;
  this.init = function (selector, options, index) {
    self.$el = $(selector);
    self.markers = [];
    var mapOptions = {
      zoom: 13,
      center: new google.maps.LatLng(52.2297, 21.0122), // wawa
    };
    var mapElement = self.$el.find('#map_1').get(index);
    // Create the Google Map using our element and options defined above
    self.map = new google.maps.Map(mapElement, mapOptions);

    self.$el.find('[name="inpostSearch"]').on("keypress", function (event) {
      if (event.which === 13) {
        event.preventDefault();
      }
      if (event.currentTarget.value.length > 3) {
        Inpost.searchPostBoxes({address: event.currentTarget.value}, self.onInpostSearchResults);
      }
    });
    self.$el.find('.btn-inpost-search').on('click', function () {
      var text = self.$el.find('[name="inpostSearch"]').val();
      if (text && text.length > 3) {
        Inpost.searchPostBoxes({address: text}, self.onInpostSearchResults);
      }
    });


    if (options.initValue) {
      try {
        var postbox = typeof options.initValue === "object" ? options.initValue : JSON.parse(options.initValue);
        self.results = {
          count: 1,
          items: [postbox]
        };
        self.updateInpostBoxes();
        self.updateMarkers();
        self.map.setCenter({lat: postbox.location.latitude, lng: postbox.location.longitude});
        self.map.setZoom(17);
        $('.choosed #inpostPostBoxesList').select2().val(postbox.name).trigger('change');
      } catch (e) {
        //silent
      }
    }
  };

  this.onInpostSearchResults = function (results) {
    if (results && results.count > 0) {
      results.items = results.items.sort(function (a, b) {
        if (a.address.line1.toLowerCase() < b.address.line1.toLowerCase()) {
          return -1;
        }
        if (b.address.line1.toLowerCase() < a.address.line1.toLowerCase()) {
          return 1;
        }
        return 0;
      });
      self.results = results;
      self.centerMap(results.items[0].location);
    }
    self.results = results;
    self.updateInpostBoxes();
    self.updateMarkers();
    self.$el.show();
  };

  this.updateInpostBoxes = function () {
    var $select = $('.choosed #inpostPostBoxesList');
    if (self.results && self.results.count > 0) {
      $('.choosed #inpostPostBoxes').show();
      if ($select.hasClass("select2-hidden-accessible")) {
        $select.select2("destroy");
      }
      $select.find('option').remove();
      $select.append("<option></option>");
      $select.select2().on('select2:select', function (e) {
        for (var mi = 0; mi < self.markers.length; mi++) {
          if (self.markers[mi].postbox === e.params.data.id) {
            self.map.setZoom(17);
            self.map.panTo(self.markers[mi].marker.position);
            var item = self.results.items.filter(function (item) {
              return item.name === e.params.data.id;
            });
            self.setPostbox(item[0]);
            break;
          }
        }
      });
      self.results.items.forEach(function (item) {
        var newOption = new Option(item.address.line1 + " " + item.address.line2, item.name, false, false);
        $select.select2().append(newOption).trigger('change');
      });
    }
  };

  this.updateMarkers = function () {
    if (self.results && self.results.count > 0) {
      self.markers.forEach(function (marker) {
        marker.marker.setMap(null);
      });
      self.markers.length = 0;
      self.results.items.forEach(function (item) {
        var marker = new google.maps.Marker({
          position: {lat: item.location.latitude, lng: item.location.longitude},
          map: self.map,
          title: item.name
        });
        var infoWindow = new google.maps.InfoWindow({
          content: '<div id="content">' +
            '<h4 id="firstHeading" class="firstHeading">' + item.name + '</h4>' +
            '<div id="bodyContent">' +
            '<p>' + item.address.line1 + '<br/>' + item.address.line2 + '</p>' +
            '</div></div>'
        });
        marker.addListener('mouseover', function () {
          infoWindow.open(CheckoutPage.map, marker);
        });
        marker.addListener('mouseout', function () {
          infoWindow.close();
        });
        marker.addListener('click', function () {
          self.map.setZoom(17);
          self.map.setCenter(marker.getPosition());
          self.setPostbox(item);
          $('#inpostPostBoxesList').val(item.name).trigger('change');
        });

        self.markers.push({
          postbox: item.name,
          info: infoWindow,
          marker: marker
        });
      });
    }
  };

  this.setPostbox = function (item) {
    $('[name="postbox"]').val(JSON.stringify({name: item.name, location: item.location, address: item.address}));
  };

  this.show = function (options) {
    if (options && options.address) {
      Inpost.searchPostBoxes(options, function (results) {
        self.onInpostSearchResults(results);
        self.$el.show();
      });
    } else {
      self.$el.show();
    }
  };

  this.hide = function () {
    self.$el.hide();
  };

  this.centerMap = function (coords) {
    self.map && self.map.setCenter({lat: coords.latitude, lng: coords.longitude});
  };
};

$(CheckoutPage.init);